/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { BreadcrumbV2Model, SkuRecordModel } from './browse-search-types';

/** Vehicle configuration model representing the user selected vehicle. */
export interface BaseVehicleModel {
  /**
   * The vehicle year.
   * @format int32
   * @example 2023
   */
  year: number;
  /**
   * The vehicle make Id.
   * @format int32
   * @example 75
   */
  makeId: number;
  /**
   * The vehicle model Id.
   * @format int32
   * @example 1011
   */
  modelId: number;
  /**
   * The vehicle type Id.
   * @format int32
   * @example 5
   */
  vehicleTypeId?: number;
}

export interface InterchangeRequestParamModel {
  /**
   * Searching part type
   * @example "Disc Brake Rotor Set"
   */
  partType?: string;
  /**
   * Searching part number
   * @example "28890-5DA1B"
   */
  partNumber: string;
  /**
   * Interchange match type
   * @example "EXACT"
   */
  matchType: 'EXACT' | 'CONTAINS';
}

export interface ProductSearchRequestModel {
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property.
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * Indicated whether preview data should be used.
   * @example false
   */
  preview: boolean;
  /**
   * This parameter represents the user searched term, this can be a parttype title search, partnumber search, item id search, or parttype title with vehicle terms
   * @example "spark plug"
   */
  searchText: string;
  /** Vehicle configuration combination inputted by the user that represents a vehicle */
  baseVehicle?: BaseVehicleModel;
  /**
   * Vehicle question dictionary with the answers.
   * @example {"subModel":21,"driveTypeId":1}
   */
  vehicleQuestions?: Record<string, string>;
  /**
   * This parameter represents the number of Stock Keeping Unit (SKU) records to show on the page. If this parameter is not passed, the default number of results configured in the predictive merchandising tool will be returned.
   * @format int32
   * @example 12
   */
  recordsPerPage: number;
  /**
   * This parameter represents the pagenumber user viewing, the default is first page
   * @format int32
   * @example 2
   */
  pageNumber?: number;
  /**
   * This parameter represents the store user added to his profile, this parameter can be used for search results relevancy, if this parameter is not passed default sort configured in the predictive merchandising tool will be applied
   * @format int32
   * @example 3181
   */
  storeId?: number;
  /**
   * This parameter represents the segmentations user belongs.
   * @example ["LasVegas SDD Segment"]
   */
  userSegments?: string[];
  /**
   * Device type of a requester which is used to control response view
   * @example "app"
   */
  deviceType?: 'app';
  /**
   * This parameter represents the facet attribute user selected to narrow down the search results
   * @example "bci_group_size_s:1++cold_cranking_amperage_s:575A"
   */
  facet?: string;
  /**
   * The skipPdpRedirect flag indicates whether redirection to the Product Details Page should be skipped.
   * @example false
   */
  skipPdpRedirect?: boolean;
  /**
   * Skip semantic search. Force text match using
   * @example false
   */
  skipSemanticSearch?: boolean;
  /**
   * The Profile Id from the User performing the search
   * @example 24761867600640
   */
  userProfileId?: string;
  /**
   * This parameter adds debug info into the response.
   * @example false
   */
  debug?: boolean;
  /**
   * Used to display only items that fit a vehicle so that incompatible, or irrelevant results are not showed
   * @example false
   */
  isVehicleSpecific?: boolean;
  /**
   * The ignoreVehicleSpecificProductsCheck flag indicates whether Vehicle Specific Products Check is required or not.
   * @example false
   */
  ignoreVehicleSpecificProductsCheck?: boolean;
  /**
   * This parameter indicates whether the group redirect is required or not for the visual keyword.
   * @example false
   */
  keywordSearchVisual?: boolean;
  /** This parameter represents the sort attribute to sort the search results */
  sort?: SortingTypeModel;
  /** This parameter represents the interchange attribute to search results */
  interchange?: InterchangeRequestParamModel;
  /**
   * The record type of the products searched for.
   * @example "APP"
   */
  recordType?: 'ALL' | 'APP' | 'NON_APP';
  /**
   * The min price that is associated to the price applied by user from the price facet.
   * @format int32
   * @example 10
   */
  minPrice?: number;
  /**
   * The max price that is associated to the price applied by user from the price facet.
   * @format int32
   * @example 50
   */
  maxPrice?: number;
}

export enum SortingTypeModel {
  Featured = 'featured',
  PriceAsc = 'price-asc',
  PriceDesc = 'price-desc',
  RecentlyAdded = 'recently-added',
  CustomerRating = 'customer-rating',
  BestSellers = 'best-sellers',
}

/** Response model to represent the single facet from the search results. */
export interface FacetModel {
  /**
   * The facet name to display on the User Interface
   * @example "Brand"
   */
  facetDisplayName: string;
  /**
   * The flag to enable facet options for multi-select.
   * @example false
   */
  multiSelectFlag: boolean;
  /**
   * The facet name used internally is different from facetDisplayName for some facets.
   * @example "brand_name_fltr"
   */
  facetInternalName: string;
  /** The list of facet options. */
  facetValues?: FacetValueModel[];
  /** The flag used for quick filter facets. */
  isOneClickFilter?: boolean;
}

/** Response model to represent the single facet value and its specifications */
export interface FacetValueModel {
  /**
   * This indicates the optional bot enable brand facet path.
   * @example "/b/brand/duralast"
   */
  botEnabledFacetPath: string;
  /**
   * The Bot SEO URL without the current facet value selection.
   * @example "/b/brand/batteries-starting-and-charging/battery"
   */
  botSeoUrl: string;
  /**
   * The facet value display name is to show on the User Interface.
   * @example "Duralast"
   */
  facetValueDisplayName: string;
  /**
   * The facet value internal name is used to generate Seo URL for LucidWorks side.
   * @example "Duralast"
   */
  facetValueInternalName: string;
  /**
   * The property represents the number of Stock Keeping Units (SKUs) tagged to the facet value.
   * @format int32
   * @example 30
   */
  itemCount?: number;
  /**
   * The flag to represent the facet value selected or not.
   * @example false
   */
  selectedFlag: boolean;
  /**
   * The SEO URL with the current facet value is selected.
   * @example "/batteries-starting-and-charging/battery?facet=brand:Duralast"
   */
  seoUrl: string;
}

/** Object containing the global warranty properties */
export interface GlobalWarrantyModel {
  /**
   * This represents the number of months an item has the global warranty.
   * @format int32
   */
  warrantyMonths?: number;
  /** The global warranty period for the product. */
  warrantyText?: string;
  /** The global warranty type for the item. */
  warrantyType?: string;
}

/** Object with the part type information. */
export interface PartTypeRecordModel {
  /**
   * This represents the unique document Id.
   * @example "1052868_00170_BA42-4UT_GPS_0_0_0_0_0_0_1073721_00134_en_us"
   */
  documentId: string;
  /**
   * This represents the product image URL
   * @example "https://contentinfo.autozone.com/znetcs/product-info/en/US/res/7008620/image/2/"
   */
  productImageUrl?: string;
  /**
   * This represents the part type SEO URL
   * @example "/batteries-starting-and-charging/battery"
   */
  productSeoUrl?: string;
  /**
   * Score of each document in SKU Records.
   * @format double
   * @example 234.56
   */
  score?: number;
  /**
   * This represents the taxonomy path used to query Lucidworks
   * @example "/parts/batteries-starting-and-charging/batteries/battery"
   */
  taxonomyPath?: string;
  /**
   * Standardized ACES/PIES part terminology identifier. Used to ensure consistency and accuracy when exchanging information about parts between manufacturers, suppliers, and retailers.
   * @example 1862
   */
  partTerminologyId?: string;
  /**
   * Part Group identifier that this part type is part of.
   * @example "azpg1234"
   */
  partGroupId?: string;
  /**
   * Part Group Name that this part type is part of.
   * @example "Car Battery"
   */
  partGroupName?: string;
  /**
   * Canonical Url for the Part Group
   * @example "/brakes-and-abs/parking-brake-hardware"
   */
  canonicalUrl?: string;
  /**
   * Category Id path for this part type
   * @example "ae5444d6-5d85-4791-a54e-7d37164e/a55d7e11-6581-4457-bdf5-a91746f1/f117d89e-dcfd-4888-be96-7b66821d/90270916-73ab-48d6-ae09-eeb0585c"
   */
  categoryIdPath?: string;
}

/** Object containing the availability types of the product. */
export interface ProductAvailabilityModel {
  /**
   * flag that indicates if the product is bopus available.
   * @example true
   */
  bopus?: boolean;
}

/** Product search response model for client consumption. */
export interface ProductSearchResponseModel {
  /**
   * This indicates the redirect URL that needs to be called from client.
   * @example "/batteries-starting-and-charging/battery/p/duralast-platinum-efb-battery-h8-efb-group-size-h8-850-cca/1070589_0_0"
   */
  redirectUrl: string;
  /**
   * This is used to uniquely identify a request as well as perform stable access tracing.
   * @example "bQK4aRXbmE"
   */
  xfusionQueryId?: string;
  /**
   * The test experience the user belongs to. Used for Adobe Analytics
   * @example "A"
   */
  lwTestExperience?: string;
  /**
   * This property is populated if we matched only one SKU
   * @example 605363
   */
  matchItemId?: string;
  /**
   * This property is populated if we matched only one part group
   * @example "azpg1234"
   */
  matchPartGroupId?: string;
  /**
   * This represents whether the item is an interchange part number match for the searched part number or not.
   * @example true
   */
  interchangeSearchFlag?: boolean;
  /**
   * This indicates the original equipment manufacturer brand name.
   * @example "Duralast"
   */
  oemBrandName?: string;
  /**
   * This indicates the original equipment manufacturer part number
   * @example "H6-DLG"
   */
  oemPartNumber?: string;
  /** Search results data. */
  searchResults?: ProductSearchResultsModel;
  /** Debug object */
  debug?: SearchDebugModel;
}

/** Response model to represent the browse or search results */
export interface ProductSearchResultsModel {
  /** An applicable facets list for the search results. */
  facets?: FacetModel[];
  /** An applicable facets list for quick selection in the search results. */
  quickFilters?: FacetModel[];
  /**
   * The first record number from the search results
   * @format int32
   * @example 1
   */
  firstRecordNumber?: number;
  /**
   * The last record number from the search results
   * @format int32
   * @example 12
   */
  lastRecordNumber?: number;
  /**
   * The number of records to display on the page
   * @format int32
   * @example 12
   */
  recordsPerPage: number;
  /**
   * The total number of records returned from the search
   * @format int32
   * @example 200
   */
  totalNumberOfRecords?: number;
  /**
   * year of the vehicle from the search
   * @format int32
   * @example 2022
   */
  year?: number;
  /**
   * make Id of the vehicle from the search
   * @format int32
   * @example 25
   */
  makeId?: number;
  /**
   * model Id of the vehicle from the search
   * @format int32
   * @example 187
   */
  modelId?: number;
  /**
   * make name of the vehicle from the search
   * @example "Honda"
   */
  makeName?: string;
  /**
   * model name of the vehicle from the search
   * @example "Accord"
   */
  modelName?: string;
  /**
   * sub model name of the vehicle from the search
   * @example "SCT"
   */
  subModelName?: string;
  /**
   * sub model id of the vehicle from the search
   * @format int32
   * @example 671
   */
  subModelId?: number;
  /**
   * unitOfMeasureMatch is a Boolean that returns true if a product is searched with any unit of measure.
   * @example false
   */
  unitOfMeasureMatch?: boolean;
  /** A list of matched part type records from the search */
  visualCategories?: PartTypeRecordModel[];
  /**
   * This indicates the original searched keyword terms that the search results belong too
   * @example "batteries"
   */
  searchedKeyword: string;
  /**
   * This indicates the corrected keyword terms that the search results belong to.
   * @example "batteries"
   */
  correctedTerm?: string;
  /**
   * Flag that returns true if a product is searched with any part number.
   * @example false
   */
  partNumberSearch?: boolean;
  /**
   * Time required by Solr to process the query
   * @format int32
   * @example 10
   */
  queryTime?: number;
  /** A list of matched Stock Keeping Unit (SKU) records from the search */
  skuRecords?: SkuRecordModel[];
}

export interface SearchDebugModel {
  ruleRedirect?: string;
  finalStage?: StageInfoModel;
  semanticSearchPhrase?: string;
  stagesHistory?: StageInfoModel[];
  requestedParams?: string;
  solrParams?: Record<string, string[]>;
  semanticHandlerResponse?: object;
}

export interface StageInfoModel {
  name?: string;
  /** @format int32 */
  cutoff?: number;
  /** @format int32 */
  numFound?: number;
  dot?: string;
  parameters?: Record<string, string>;
  partNumberSearch?: boolean;
}

export interface VehicleFitmentModel {
  /**
   * This indicates item fits to the vehicle or not.
   * @example "FIT"
   */
  vehicleFit?: 'NEEDS_BASE_VEHICLE' | 'DOES_NOT_FIT' | 'NEEDS_MORE_INFO' | 'FITS';
  /**
   * The label to show on UI based on the item vehicle fitment.
   * @example "VEHICLE_SPECIFIC"
   */
  vehicleFitmentLabel?: string;
}

export interface PartTypesSearchRequestModel {
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property.
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * Indicated whether preview data should be used.
   * @example false
   */
  preview: boolean;
  /**
   * This parameter represents the user searched term, this can be a parttype title search, partnumber search, item id search, or parttype title with vehicle terms
   * @example "spark plug"
   */
  searchText: string;
  /** Vehicle configuration combination inputted by the user that represents a vehicle */
  baseVehicle?: BaseVehicleModel;
  /**
   * Vehicle question dictionary with the answers.
   * @example {"subModel":21,"driveTypeId":1}
   */
  vehicleQuestions?: Record<string, string>;
  /**
   * This parameter represents the number of Stock Keeping Unit (SKU) records to show on the page. If this parameter is not passed, the default number of results configured in the predictive merchandising tool will be returned.
   * @format int32
   * @example 12
   */
  recordsPerPage: number;
  /**
   * This parameter represents the pagenumber user viewing, the default is first page
   * @format int32
   * @example 2
   */
  pageNumber?: number;
  /**
   * This parameter represents the store user added to his profile, this parameter can be used for search results relevancy, if this parameter is not passed default sort configured in the predictive merchandising tool will be applied
   * @format int32
   * @example 3181
   */
  storeId?: number;
  /**
   * This parameter represents the segmentations user belongs.
   * @example ["LasVegas SDD Segment"]
   */
  userSegments?: string[];
  /**
   * Device type of a requester which is used to control response view
   * @example "app"
   */
  deviceType?: 'app';
  /**
   * This parameter represents the facet attribute user selected to narrow down the search results
   * @example "bci_group_size_s:1++cold_cranking_amperage_s:575A"
   */
  facet?: string;
  /**
   * The skipPdpRedirect flag indicates whether redirection to the Product Details Page should be skipped.
   * @example false
   */
  skipPdpRedirect?: boolean;
  /**
   * Skip semantic search. Force text match using
   * @example false
   */
  skipSemanticSearch?: boolean;
  /**
   * The Profile Id from the User performing the search
   * @example 24761867600640
   */
  userProfileId?: string;
  /**
   * This parameter adds debug info into the response.
   * @example false
   */
  debug?: boolean;
  /**
   * Used to display only items that fit a vehicle so that incompatible, or irrelevant results are not showed
   * @example false
   */
  isVehicleSpecific?: boolean;
  /**
   * The ignoreVehicleSpecificProductsCheck flag indicates whether Vehicle Specific Products Check is required or not.
   * @example false
   */
  ignoreVehicleSpecificProductsCheck?: boolean;
  /**
   * This parameter indicates whether the group redirect is required or not for the visual keyword.
   * @example false
   */
  keywordSearchVisual?: boolean;
  /**
   * This parameter represents the sort attribute to sort the search results
   * @default "featured"
   */
  sort?: 'FEATURED';
}

/** Part type search response model for client consumption. */
export interface PartTypesSearchResponseModel {
  /**
   * This indicates the redirect URL that needs to be called from client.
   * @example "/batteries-starting-and-charging/battery/p/duralast-platinum-efb-battery-h8-efb-group-size-h8-850-cca/1070589_0_0"
   */
  redirectUrl: string;
  /**
   * This is used to uniquely identify a request as well as perform stable access tracing.
   * @example "bQK4aRXbmE"
   */
  xfusionQueryId?: string;
  /**
   * The test experience the user belongs to. Used for Adobe Analytics
   * @example "A"
   */
  lwTestExperience?: string;
  /**
   * This property is populated if we matched only one SKU
   * @example 605363
   */
  matchItemId?: string;
  /**
   * This property is populated if we matched only one part group
   * @example "azpg1234"
   */
  matchPartGroupId?: string;
  /**
   * This represents whether the item is an interchange part number match for the searched part number or not.
   * @example true
   */
  interchangeSearchFlag?: boolean;
  /**
   * This indicates the original equipment manufacturer brand name.
   * @example "Duralast"
   */
  oemBrandName?: string;
  /**
   * This indicates the original equipment manufacturer part number
   * @example "H6-DLG"
   */
  oemPartNumber?: string;
  /** Search results data. */
  searchResults?: PartTypesSearchResultsModel;
}

/** Response model to represent the search part type results */
export interface PartTypesSearchResultsModel {
  /** An applicable facets list for the search results. */
  facets?: FacetModel[];
  /** An applicable facets list for quick selection in the search results. */
  quickFilters?: FacetModel[];
  /**
   * The first record number from the search results
   * @format int32
   * @example 1
   */
  firstRecordNumber?: number;
  /**
   * The last record number from the search results
   * @format int32
   * @example 12
   */
  lastRecordNumber?: number;
  /**
   * The number of records to display on the page
   * @format int32
   * @example 12
   */
  recordsPerPage: number;
  /**
   * The total number of records returned from the search
   * @format int32
   * @example 200
   */
  totalNumberOfRecords?: number;
  /**
   * year of the vehicle from the search
   * @format int32
   * @example 2022
   */
  year?: number;
  /**
   * make Id of the vehicle from the search
   * @format int32
   * @example 25
   */
  makeId?: number;
  /**
   * model Id of the vehicle from the search
   * @format int32
   * @example 187
   */
  modelId?: number;
  /**
   * make name of the vehicle from the search
   * @example "Honda"
   */
  makeName?: string;
  /**
   * model name of the vehicle from the search
   * @example "Accord"
   */
  modelName?: string;
  /**
   * sub model name of the vehicle from the search
   * @example "SCT"
   */
  subModelName?: string;
  /**
   * sub model id of the vehicle from the search
   * @format int32
   * @example 671
   */
  subModelId?: number;
  /**
   * This indicates the original searched keyword terms that the search results belong to.
   * @example "batteries"
   */
  searchedKeyword: string;
  /**
   * This indicates the corrected keyword terms that the search results belong to.
   * @example "batteries"
   */
  correctedTerm?: string;
  /** A list of matched Part Types from the search */
  partTypes?: PartTypeRecordModel[];
  /**
   * Flag that returns true if a product is searched with any part number.
   * @example false
   */
  partNumberSearch?: boolean;
  /**
   * Time required by Solr to process the query
   * @format int32
   * @example 10
   */
  queryTime?: number;
}

/** Request model object to get the interchange search results. */
export interface InterchangeSearchRequestModel {
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property.
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * Indicated whether preview data should be used.
   * @example false
   */
  preview: boolean;
  /** Vehicle configuration combination inputted by the user that represents a vehicle */
  baseVehicle?: BaseVehicleModel;
  /**
   * Vehicle question dictionary with the answers.
   * @example {"ques_1":"ans_1","ques_2":"ans_2"}
   */
  vehicleQuestions?: Record<string, string>;
  /**
   * This parameter represents the number of Stock Keeping Unit (SKU) records to show on the page. If this parameter is not passed, the default number of results configured in the predictive merchandising tool will be returned.
   * @format int32
   * @example 20
   */
  recordsPerPage: number;
  /**
   * This parameter represents the pagenumber user viewing, the default is first page
   * @format int32
   * @example 1
   */
  pageNumber?: number;
  /**
   * This parameter represents the store user added to his profile, this parameter can be used for search results relevancy, if this parameter is not passed default sort configured in the predictive merchandising tool will be applied
   * @format int32
   * @example 3181
   */
  storeId?: number;
  /**
   * Indicates if the search should match exactly the search term
   * @default "true"
   * @example true
   */
  exactMatch: boolean;
  /**
   * Identifier of a particular AutoZone's part. Its purpose is to reference the item.
   * @example "D1184A"
   */
  partNumber: string;
  /**
   * Part Group Name that this part type is part of.
   * @example "Battery"
   */
  partGroupName?: string;
  /**
   * Device type of a requester which is used to control response view
   * @example "app"
   */
  deviceType?: 'app';
  /**
   * This parameter represents the facet attribute user selected to narrow down the search results
   * @example "bci_group_size_s:1++cold_cranking_amperage_s:575A"
   */
  facet?: string;
  /**
   * This indicates the category id that the category belong to.
   * @example "d0a7b334-6fb9-4ce6-a6f9-a2874d73/0530d388-0205-4a72-b307-b5a7458e/8b028372-b297-48fd-8585-d7bca4cf/1744"
   */
  categoryIdPath?: string;
}

/** Container with the category information */
export interface CategoryContainerRecordModel {
  /**
   * The first record number from the search results
   * @format int32
   * @example 1
   */
  firstRecordNumber: number;
  /**
   * The last record number from the search results
   * @format int32
   * @example 12
   */
  lastRecordNumber: number;
  /**
   * The number of records to display on the page
   * @format int32
   * @example 12
   */
  recordsPerPage: number;
  /**
   * The total number of records returned from the search
   * @format int32
   * @example 200
   */
  totalNumberOfRecords: number;
  /**
   * This indicates the category id that the category belong to.
   * @example "d0a7b334-6fb9-4ce6-a6f9-a2874d73/0530d388-0205-4a72-b307-b5a7458e/8b028372-b297-48fd-8585-d7bca4cf/1744"
   */
  categoryIdPath?: string;
  /**
   * The name of the category
   * @example "Auto Parts"
   */
  categoryName: string;
  /**
   * This represents the unique document Id.
   * @example "1052868_00170_BA42-4UT_GPS_0_0_0_0_0_0_1073721_00134_en_us"
   */
  documentId: string;
  /**
   * This indicates the taxonomy path that the category belong too.
   * @example "/parts"
   */
  taxonomyPath: string;
  /**
   * This represents the category SEO URL, can be different than taxonomyPath.
   * @example "/parts"
   */
  categorySeoUrl: string;
  /** The child part types of the category. */
  partTypeRecords?: PartTypeRecordModel[];
}

export interface InterchangeResponseValueModel {
  /**
   * Searching part type
   * @example "Disc Brake Rotor Set"
   */
  partType?: string;
  /**
   * Searching part number
   * @example "28890-5DA1B"
   */
  partNumber?: string;
  /**
   * Interchange match type
   * @example "EXACT"
   */
  matchType: 'EXACT' | 'CONTAINS';
}

/** Interchange search response model for client consumption. */
export interface InterchangeSearchResponseModel {
  /**
   * This indicates the original equipment manufacturer part number
   * @example "S8A"
   */
  oemPartNumber?: string;
  /** Interchange search results data. */
  searchResults?: InterchangeSearchResultModel;
  /** Interchange values */
  interchange?: InterchangeResponseValueModel;
  /**
   * This indicates the redirect URL that needs to be called from client.
   * @example "/batteries-starting-and-charging/battery/p/duralast-platinum-efb-battery-h8-efb-group-size-h8-850-cca/1070589_0_0"
   */
  redirectUrl?: string;
  /**
   * This property is populated if we matched only one SKU
   * @example 605363
   */
  matchItemId?: string;
  /**
   * This property is populated if we matched only one part group
   * @example "azpg1234"
   */
  matchPartGroupId?: string;
  /** This is the cross brand name of an item. */
  crossBrand?: string;
  /** This is the cross part number of an item. */
  crossPartNumber?: string;
}

/** Response model to represent the interchange search results */
export interface InterchangeSearchResultModel {
  /** An applicable facets list for the search results. */
  facets?: FacetModel[];
  /**
   * Time required by Solr to process the query
   * @format int32
   * @example 10
   */
  queryTime?: number;
  /** A list of matched SKU records from the search */
  categories?: CategoryContainerRecordModel[];
}

/** Request model object to get the search results. */
export interface CategoryPartTypesRequestModel {
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property.
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * Indicated whether preview data should be used.
   * @example false
   */
  preview: boolean;
  /**
   * This parameter represents the user searched term, this can be a parttype title search, partnumber search, item id search, or parttype title with vehicle terms
   * @example "spark plug"
   */
  searchText: string;
  /** Vehicle configuration combination inputted by the user that represents a vehicle */
  baseVehicle?: BaseVehicleModel;
  /**
   * Vehicle question dictionary with the answers.
   * @example {"subModel":21,"driveTypeId":1}
   */
  vehicleQuestions?: Record<string, string>;
  /**
   * This parameter represents the number of Stock Keeping Unit (SKU) records to show on the page. If this parameter is not passed, the default number of results configured in the predictive merchandising tool will be returned.
   * @format int32
   * @example 12
   */
  recordsPerPage: number;
  /**
   * This parameter represents the pagenumber user viewing, the default is first page
   * @format int32
   * @example 2
   */
  pageNumber?: number;
  /**
   * This parameter represents the store user added to his profile, this parameter can be used for search results relevancy, if this parameter is not passed default sort configured in the predictive merchandising tool will be applied
   * @format int32
   * @example 3181
   */
  storeId?: number;
  /**
   * This parameter represents the segmentations user belongs.
   * @example ["LasVegas SDD Segment"]
   */
  userSegments?: string[];
  /**
   * Device type of a requester which is used to control response view
   * @example "app"
   */
  deviceType?: 'app';
  /**
   * This parameter represents the facet attribute user selected to narrow down the search results
   * @example "bci_group_size_s:1++cold_cranking_amperage_s:575A"
   */
  facet?: string;
  /**
   * The skipPdpRedirect flag indicates whether redirection to the Product Details Page should be skipped.
   * @example false
   */
  skipPdpRedirect?: boolean;
  /**
   * Skip semantic search. Force text match using
   * @example false
   */
  skipSemanticSearch?: boolean;
  /**
   * The Profile Id from the User performing the search
   * @example 24761867600640
   */
  userProfileId?: string;
  /**
   * This parameter adds debug info into the response.
   * @example false
   */
  debug?: boolean;
  /**
   * This indicates the category id that the category belong to.
   * @example "d0a7b334-6fb9-4ce6-a6f9-a2874d73/0530d388-0205-4a72-b307-b5a7458e/8b028372-b297-48fd-8585-d7bca4cf/1744"
   */
  categoryIdPath?: string;
  /**
   * Indicates if the search should match exactly the search term
   * @default "true"
   * @example true
   */
  exactMatch?: boolean;
  /**
   * The record type of the products searched for.
   * @example "APP"
   */
  recordType?: 'ALL' | 'APP' | 'NON_APP';
  /**
   * Customer ID for the request
   * @example 12345
   */
  customerId?: string;
  /**
   * This indicates if vehicle specific facet preselection should be ignored
   * @example true
   */
  ignoreVehicleSpecificProductsCheck?: boolean;
}

/** Category search response model for client consumption. */
export interface CategoryPartTypesSearchResponseModel {
  /**
   * This indicates the redirect URL that needs to be called from client.
   * @example "/batteries-starting-and-charging/battery/p/duralast-platinum-efb-battery-h8-efb-group-size-h8-850-cca/1070589_0_0"
   */
  redirectUrl: string;
  /**
   * This is used to uniquely identify a request as well as perform stable access tracing.
   * @example "bQK4aRXbmE"
   */
  xfusionQueryId?: string;
  /**
   * The test experience the user belongs to. Used for Adobe Analytics
   * @example "A"
   */
  lwTestExperience?: string;
  /**
   * This property is populated if we matched only one SKU
   * @example 605363
   */
  matchItemId?: string;
  /**
   * This property is populated if we matched only one part group
   * @example "azpg1234"
   */
  matchPartGroupId?: string;
  /** Category search results data. */
  searchResults?: CategoryPartTypesSearchResultModel;
  /** Debug object */
  debug?: SearchDebugModel;
}

/** Response model to represent the search products results */
export interface CategoryPartTypesSearchResultModel {
  /**
   * This indicates the corrected keyword terms that the search results belong to.
   * @example "batteries"
   */
  correctedTerm?: string;
  /** An applicable facets list for the search results. */
  facets?: FacetModel[];
  /**
   * Flag that returns true if a product is searched with any part number.
   * @example false
   */
  partNumberSearch?: boolean;
  /**
   * Time required by Solr to process the query
   * @format int32
   * @example 10
   */
  queryTime?: number;
  /**
   * This indicates the original searched keyword terms that the search results belong to.
   * @example "batteries"
   */
  searchedKeyword: string;
  /**
   * year of the vehicle from the search
   * @format int32
   * @example 2022
   */
  year?: number;
  /**
   * make Id of the vehicle from the search
   * @format int32
   * @example 25
   */
  makeId?: number;
  /**
   * model Id of the vehicle from the search
   * @format int32
   * @example 187
   */
  modelId?: number;
  /**
   * make name of the vehicle from the search
   * @example "Honda"
   */
  makeName?: string;
  /**
   * model name of the vehicle from the search
   * @example "Accord"
   */
  modelName?: string;
  /**
   * sub model name of the vehicle from the search
   * @example "SCT"
   */
  subModelName?: string;
  /**
   * sub model id of the vehicle from the search
   * @format int32
   * @example 671
   */
  subModelId?: number;
  /** This is the cross brand name of an item. */
  crossBrand?: string;
  /** This is the cross part number of an item. */
  crossPartNumber?: string;
  /** A list of matched SKU records from the search */
  categories?: CategoryContainerRecordModel[];
  /** List of the vehicle specifications. */
  specifications?: TwaDocumentModel[];
  /** List of the Installation Instructions available for the vehicle. */
  installationInstructions?: TwaDocumentModel[];
  /** List of the trusted advices available for the vehicle. */
  trustedAdvices?: TwaDocumentModel[];
  /** List of the component locations available for the vehicle. */
  componentLocations?: TwaDocumentModel[];
  /** List of jobs related to the search */
  jobs?: JobModel[];
}

/** Job details */
export interface JobModel {
  /**
   * Name of the job
   * @example "Sport"
   */
  jobName?: string;
  /**
   * ID of the job
   * @example 2004
   */
  jobId?: string;
  /**
   * Customer ID associated with the job
   * @example 783656
   */
  customerId?: string;
}

/** Trustworthy advice linked to the user selected vehicle. */
export interface TwaDocumentModel {
  /**
   * Part Group identifier that this part type is part of.
   * @example "azpg1234"
   */
  partGroupId?: string;
  /**
   * Part Group Name that this part type is part of.
   * @example "Car Battery"
   */
  partGroupName?: string;
  /**
   * The name of the trustworthy advice.
   * @example "Modern Vehicle Note / Battery"
   */
  name?: string;
  /**
   * Text displayed to the user with relevant information about the trustworthy advice.
   * @example "Your vehicle came with start/stop and/or high electrical accessories which can impact battery life; recommend Duralast Platinum batteries which are designed for this technology & increased electrical loads."
   */
  text?: string;
  /**
   * Map of attributes that are part of the trustworthy advice, this will only come when the type is "Specification".
   * @example {"BCI Group Size":"94R"}
   */
  attributes?: Record<string, string>;
  /**
   * The Trustworthy advice type.
   * @example "Specification"
   */
  type?: string;
  /**
   * The Trustworthy advice sub type.
   * @example "Computer Reset"
   */
  subType?: string;
  /**
   * Array of images related to this Trustworthy advice.
   * @example ["https://www.autozonepro.com/cdn/images/B2B/US/media/vehicle-note-battery.jpg"]
   */
  images?: string[];
}

/**
 * This Free-Form Map contains the dynamic properties returned from the Solr handler. Always containing a response header
 * @example {"responseHeader":{"status":0,"QTime":0},"additionalProperty1":0,"additionalProperty2":"some example"}
 */
export interface CustomSolrResponseModel {
  /** Contains the response header from the Solr handler. */
  responseHeader?: ResponseHeaderModel;
}

export interface ResponseHeaderModel {
  /**
   * the Solr status of the request that usually corresponds to the http code, being 0 the same as 200
   * @format int32
   * @example 0
   */
  status?: number;
  /**
   * The time Solr spent processing the request
   * @format int32
   */
  QTime?: number;
}

export interface ShopByYearRangeModel {
  /** @example 2000 */
  linkDisplayText?: string;
  /** @example "/alternators-starters/ford/e-350-econoline-club-wagon/2000" */
  makeModelYearPath?: string;
  /** @example "/parts/alternators-starters/ford/e-350-econoline-club-wagon/2000" */
  seoUrl?: string;
}

export interface ShopByYearsResponseModel {
  /** @example "The year range for the Ford E-350 Econoline Club Wagon" */
  title?: string;
  /** @example "/alternators-starters/starter-motor" */
  canonicalPath?: string;
  /** @example "/parts/alternators-starters/starters-starter-solenoids/starter-motor" */
  taxonomyPath?: string;
  /** @example "ProductShelf" */
  pageType?: string;
  /** @example "Ford" */
  make?: string;
  /** @example "E-350 Econoline Club Wagon" */
  model?: string;
  /**
   * @format int32
   * @example 2001
   */
  year?: number;
  years?: ShopByYearRangeModel[];
}

export interface ShopByModelRangeModel {
  /** @example "Ford E-350 Econoline Club Wagon" */
  linkDisplayText?: string;
  /** @example "/alternators-starters/ford/e-350-econoline-club-wagon" */
  makeModelYearPath?: string;
  /** @example "/parts/alternators-starters/ford/e-350-econoline-club-wagon" */
  seoUrl?: string;
}

export interface ShopByModelsResponseModel {
  /** @example "Shop by Volkswagen by model" */
  title?: string;
  /** @example "/alternators-starters/starter-motor" */
  canonicalPath?: string;
  /** @example "/parts/alternators-starters/starters-starter-solenoids/starter-motor" */
  taxonomyPath?: string;
  /** @example "CategoryGrouping" */
  pageType?: string;
  modelRanges?: ShopByModelRangeModel[];
}

/** Represents a wrapper object with terms and their associated URLs grouped by a group identifier. */
export interface FilterLinkGroupModel {
  /**
   * An identifier used for grouping a list of values made up of FilterLinkMapping objects. This group identifier could be a single letter, a make, a model, or some other identifier that makes sense for a given use case.
   * @example "A"
   */
  groupIdentifier: string;
  /** Represents lists of filter terms and their associated URLs. */
  filterLinkMappings?: FilterLinkMappingModel[];
}

/** Represents a filter term and the corresponding URL link associated with that term */
export interface FilterLinkMappingModel {
  /**
   * A term made of one or more words to be used to create an anchor link associated with a link URL.
   * @example "Acura Parts"
   */
  filterTerm: string;
  /**
   * A URL associated with an anchor link from the filterTerm. The most common form of this URL is a relative link vs. an absolute link.
   * @example "/parts/acura"
   */
  filterLinkUrl: string;
}

/** Response model to represent the breadcrumb result. */
export interface BreadcrumbModel {
  /**
   * This indicates the display name that the category belong to.
   * @example "Batteries"
   */
  categoryName?: string;
  /**
   * This indicates the taxonomy path that the category belong to.
   * @example "/parts/batteries-starting-and-charging/batteries"
   */
  taxonomyPath?: string;
  /**
   * This indicates the category id that the category belong to.
   * @example "d0a7b334-6fb9-4ce6-a6f9-a2874d73/0530d388-0205-4a72-b307-b5a7458e/8b028372-b297-48fd-8585-d7bca4cf/1744"
   */
  categoryIdPath?: string;
  /**
   * Canonical Url for the Part Group
   * @example "/brakes-and-abs/parking-brake-hardware"
   */
  canonicalUrl?: string;
  /**
   * This indicates the page type that the category belong too and it could be one of from TopNavCategory, CategoryGrouping, LeafCategory and PartGroup.
   * @example "productShelf"
   */
  pageType?: string;
}

/** Product shelf response model for client consumption. */
export interface ProductShelfResponseModel {
  /** Search results data. */
  productShelfResults?: ProductShelfResultsModel;
  /**
   * This is used to uniquely identify a request as well as perform stable access tracing.
   * @example "bQK4aRXbmE"
   */
  xfusionQueryId?: string;
  /**
   * interchangeSearchFlag from LucidWorks Result
   * @example false
   */
  interchangeSearchFlag?: boolean;
  /**
   * This indicates the redirect URL that needs to be called from client.
   * @example "/batteries-starting-and-charging/battery/p/duralast-platinum-efb-battery-h8-efb-group-size-h8-850-cca/1070589_0_0"
   */
  redirectUrl: string;
}

/** Response model to represent the product results which contain the information related to products and breadcrumbs along with ymm path. */
export interface ProductShelfResultsModel {
  /** An applicable facets list for the search results. */
  facets?: FacetModel[];
  /** An applicable facets list for quick selection in the search results. */
  quickFilters?: FacetModel[];
  /**
   * The first record number from the search results
   * @format int32
   * @example 1
   */
  firstRecordNumber?: number;
  /**
   * The last record number from the search results
   * @format int32
   * @example 12
   */
  lastRecordNumber?: number;
  /**
   * The number of records to display on the page
   * @format int32
   * @example 12
   */
  recordsPerPage: number;
  /**
   * The total number of records returned from the search
   * @format int32
   * @example 200
   */
  totalNumberOfRecords?: number;
  /**
   * year of the vehicle from the search
   * @format int32
   * @example 2022
   */
  year?: number;
  /**
   * make Id of the vehicle from the search
   * @format int32
   * @example 25
   */
  makeId?: number;
  /**
   * model Id of the vehicle from the search
   * @format int32
   * @example 187
   */
  modelId?: number;
  /**
   * make name of the vehicle from the search
   * @example "Honda"
   */
  makeName?: string;
  /**
   * model name of the vehicle from the search
   * @example "Accord"
   */
  modelName?: string;
  /**
   * sub model name of the vehicle from the search
   * @example "SCT"
   */
  subModelName?: string;
  /**
   * sub model id of the vehicle from the search
   * @format int32
   * @example 671
   */
  subModelId?: number;
  /**
   * This indicates the category id that the category belong to.
   * @example "d0a7b334-6fb9-4ce6-a6f9-a2874d73/0530d388-0205-4a72-b307-b5a7458e/8b028372-b297-48fd-8585-d7bca4cf/1744"
   */
  categoryIdPath?: string;
  /**
   * This indicates the display name of the category that the product belong too.
   * @example "Batteries"
   */
  pageDisplayName: string;
  /**
   * This indicates the shop by url that the product belong too.
   * @example "/honda/civic/2018"
   */
  makeModelYearPath?: string;
  /**
   * This represents the taxonomy path used to query Lucidworks.
   * @example "/batteries-starting-and-charging/battery"
   */
  taxonomyPath: string;
  /** This contains all the breadcrumbs for the product. */
  breadCrumbs?: BreadcrumbModel[];
  /**
   * unitOfMeasureMatch is a Boolean that returns true if a product is searched with any unit of measure.
   * @example false
   */
  unitOfMeasureMatch?: boolean;
  /**
   * Part Group identifier that this part type is part of.
   * @example "azpg1234"
   */
  partGroupId?: string;
  /**
   * Part Group Name that this part type is part of.
   * @example "Car Battery"
   */
  partGroupName?: string;
  /** A list of matched Stock Keeping Unit (SKU) records from the search */
  skuRecords?: SkuRecordModel[];
  /** List of the vehicle specifications. */
  specifications?: TwaDocumentModel[];
  /** List of the Installation Instructions available for the vehicle. */
  installationInstructions?: TwaDocumentModel[];
  /** List of the trusted advices available for the vehicle. */
  trustedAdvices?: TwaDocumentModel[];
  /** List of the component locations available for the vehicle. */
  componentLocations?: TwaDocumentModel[];
  /**
   * This indicates the corrected keyword terms that the search results belong to.
   * @example "batteries"
   */
  correctedTerm?: string;
}

/** Represents a wrapper object containing part group id, part group name and list of PartTerminologyInfo. */
export interface PartGroupAndPartTerminologyInfoModel {
  /**
   * Part Group identifier that this part type is part of.
   * @example "azpg1234"
   */
  partGroupId?: string;
  /**
   * Part Group Name that this part type is part of.
   * @example "Car Battery"
   */
  partGroupName?: string;
  /** Represents lists of part terminology id and its associated part terminology name. */
  partTerminologyInfo?: PartTerminologyInfoModel[];
}

/** Represents a wrapper object containing part terminology id and part terminology name. */
export interface PartTerminologyInfoModel {
  /**
   * Part Terminology Id
   * @example 12030
   */
  partTerminologyId: string;
  /**
   * Part Terminology Name
   * @example "Ignition Switch"
   */
  partTerminologyName: string;
}

export interface PartsInterchangeModel {
  /**
   * This is the part numbers from request
   * @uniqueItems true
   * @example "[H4-DLG]"
   */
  fromPartNumberIds: string[];
  /**
   * A value that uniquely identifies an item.
   * @example 33419
   */
  itemId: string;
  /**
   * This is the brand id of an item.
   * @example "DRT"
   */
  brandId?: string;
  /**
   * Standardized ACES/PIES part terminology identifier. Used to ensure consistency and accuracy when exchanging information about parts between manufacturers, suppliers, and retailers.
   * @example 1862
   */
  partTerminologyId?: string;
  /**
   * This is the interchange part number for an item.
   * @example "L4-DLG-BVHE-2011"
   */
  partNumberId: string;
  /**
   * This is the line code of a product.
   * @example "RES"
   */
  lineCode: string;
}

/** Product search response model for client consumption. */
export interface PartsInterchangeResponseModel {
  /**
   * This indicates the redirect URL that needs to be called from client.
   * @example "/batteries-starting-and-charging/battery/p/duralast-platinum-efb-battery-h8-efb-group-size-h8-850-cca/1070589_0_0"
   */
  redirectUrl: string;
  /**
   * This is used to uniquely identify a request as well as perform stable access tracing.
   * @example "bQK4aRXbmE"
   */
  xfusionQueryId?: string;
  /**
   * The test experience the user belongs to. Used for Adobe Analytics
   * @example "A"
   */
  lwTestExperience?: string;
  /**
   * This property is populated if we matched only one SKU
   * @example 605363
   */
  matchItemId?: string;
  /**
   * This property is populated if we matched only one part group
   * @example "azpg1234"
   */
  matchPartGroupId?: string;
  /** Collection of part number interchanges */
  partsInterchanges?: PartsInterchangeModel[];
}

export interface PageTypeResponseModel {
  /** Search results data. */
  pageTypeResult?: PageTypeResultModel;
}

/** Response model to represent the page type data. */
export interface PageTypeResultModel {
  /**
   * This indicates the category id that the category belong to.
   * @example "d0a7b334-6fb9-4ce6-a6f9-a2874d73/0530d388-0205-4a72-b307-b5a7458e/8b028372-b297-48fd-8585-d7bca4cf/1744"
   */
  categoryIdPath?: string;
  /**
   * This indicates the taxonomy path that the product belong too.
   * @example "/parts/batteries-starting-and-charging/batteries/battery"
   */
  taxonomyPath: string;
  /**
   * This indicates the canonical url that the product belong too.
   * @example "/lighting/instrument-cluster-indicator-light-housing-sleeve"
   */
  canonicalUrl: string;
  /**
   * This indicates the page type that the product belong too.
   * @example "ProductShelf"
   */
  pageType: 'TopLevel' | 'CategoryGrouping' | 'LeafCategory' | 'ProductShelf' | 'ProductDetails';
  /**
   * Part Group identifier that this part type is part of.
   * @example "azpg1234"
   */
  partGroupId?: string;
  /**
   * Part Group Name that this part type is part of.
   * @example "Car Battery"
   */
  partGroupName?: string;
  /**
   * Standarized ACES/PIES part terminology identifier. Used to ensure consistency and accuracy when exchanging information about parts between manufacturers, suppliers, and retailers.
   * @example 1862
   */
  partTerminologyId?: string;
  /**
   * Standarized ACES/PIES part terminology name.
   * @example "Batteries"
   */
  partTerminologyName?: string;
  /**
   * This indicates the optional brand faced.
   * @example "/b/duralast"
   */
  botEnabledFacetPath?: string;
  /**
   * Property to indicate that product/ product canonical path is active for any Vehicle Make.
   * @example false
   */
  shopByMakeActive?: boolean;
  /**
   * Property to indicate that product/ product canonical path is active for any Vehicle Model.
   * @example false
   */
  shopByModelActive?: boolean;
  /**
   * Property to indicate that product/ product canonical path is active for any Vehicle Year.
   * @example false
   */
  shopByYearActive?: boolean;
  /**
   * This indicates the make that the product belong too.
   * @example "honda"
   */
  make?: string;
  /**
   * This indicates the make ID that the product belong too.
   * @example 72
   */
  makeId?: string;
  /**
   * This indicates the model that the product belong too.
   * @example "civic"
   */
  model?: string;
  /**
   * This indicates the model ID that the product belong too.
   * @example 12
   */
  modelId?: string;
  /**
   * This indicates the year that the product belong too.
   * @format int32
   * @example 2018
   */
  year?: number;
  /**
   * This indicates the model ID that the product belong too.
   * @example 12
   */
  vehicleTypeId?: string;
  /**
   * This indicates the shop by url that the product belong too.
   * @example "/honda/civic/2018"
   */
  makeModelYearPath?: string;
}

/** Merch shelf response model for client consumption. */
export interface MerchShelfResponseModel {
  /** Search results data. */
  merchShelfResults?: MerchShelfResultsModel;
  /**
   * This is used to uniquely identify a request as well as perform stable access tracing.
   * @example "bQK4aRXbmE"
   */
  xfusionQueryId?: string;
  /**
   * interchangeSearchFlag from LucidWorks Result
   * @example false
   */
  interchangeSearchFlag?: boolean;
  /**
   * This indicates the redirect URL that needs to be called from client.
   * @example "/batteries-starting-and-charging/battery/p/duralast-platinum-efb-battery-h8-efb-group-size-h8-850-cca/1070589_0_0"
   */
  redirectUrl?: string;
  /**
   * Google Cloud Retail attribution token for tracking user interactions
   * @example "ChwKGgoHcHJvZHVjdBIPCg0KB2NhdGVnb3J5"
   */
  attributionToken?: string;
  /**
   * Google Cloud Retail filter string in the format: attributes.field: ANY("value1", "value2")
   * @example "attributes.brand_name_fltr: ANY(\"Duralast\", \"ACDelco\") AND attributes.location_fltr: ANY(\"Front\")"
   */
  filter?: string;
}

/** Response model to represent the product results which contain the information related to products and breadcrumbs along with ymm path. */
export interface MerchShelfResultsModel {
  /** An applicable facets list for the search results. */
  facets?: FacetModel[];
  /** An applicable facets list for quick selection in the search results. */
  quickFilters?: FacetModel[];
  /**
   * The first record number from the search results
   * @format int32
   * @example 1
   */
  firstRecordNumber?: number;
  /**
   * The last record number from the search results
   * @format int32
   * @example 12
   */
  lastRecordNumber?: number;
  /**
   * The number of records to display on the page
   * @format int32
   * @example 12
   */
  recordsPerPage: number;
  /**
   * The total number of records returned from the search
   * @format int32
   * @example 200
   */
  totalNumberOfRecords?: number;
  /**
   * year of the vehicle from the search
   * @format int32
   * @example 2022
   */
  year?: number;
  /**
   * make Id of the vehicle from the search
   * @format int32
   * @example 25
   */
  makeId?: number;
  /**
   * model Id of the vehicle from the search
   * @format int32
   * @example 187
   */
  modelId?: number;
  /**
   * make name of the vehicle from the search
   * @example "Honda"
   */
  makeName?: string;
  /**
   * model name of the vehicle from the search
   * @example "Accord"
   */
  modelName?: string;
  /**
   * sub model name of the vehicle from the search
   * @example "SCT"
   */
  subModelName?: string;
  /**
   * sub model id of the vehicle from the search
   * @format int32
   * @example 671
   */
  subModelId?: number;
  /**
   * This indicates the category id that the category belong to.
   * @example "d0a7b334-6fb9-4ce6-a6f9-a2874d73/0530d388-0205-4a72-b307-b5a7458e/8b028372-b297-48fd-8585-d7bca4cf/1744"
   */
  categoryIdPath?: string;
  /**
   * This indicates the display name of the category that the product belong too.
   * @example "Batteries"
   */
  pageDisplayName: string;
  /**
   * This indicates the shop by url that the product belong too.
   * @example "/honda/civic/2018"
   */
  makeModelYearPath?: string;
  /**
   * This represents the taxonomy path used to query Lucidworks.
   * @example "/batteries-starting-and-charging/battery"
   */
  taxonomyPath: string;
  /** This contains all the breadcrumbs for the product. */
  breadCrumbs?: BreadcrumbV2Model[];
  /**
   * unitOfMeasureMatch is a Boolean that returns true if a product is searched with any unit of measure.
   * @example false
   */
  unitOfMeasureMatch?: boolean;
  /**
   * Part Group identifier that this part type is part of.
   * @example "azpg1234"
   */
  partGroupId?: string;
  /**
   * Part Group Name that this part type is part of.
   * @example "Car Battery"
   */
  partGroupName?: string;
  /** A list of matched Stock Keeping Unit (SKU) records from the search */
  skuRecords?: SkuRecordModel[];
  /** List of the vehicle specifications. */
  specifications?: TwaDocumentModel[];
  /** List of the Installation Instructions available for the vehicle. */
  installationInstructions?: TwaDocumentModel[];
  /** List of the trusted advices available for the vehicle. */
  trustedAdvices?: TwaDocumentModel[];
  /** List of the component locations available for the vehicle. */
  componentLocations?: TwaDocumentModel[];
  /**
   * This indicates the corrected keyword terms that the search results belong to.
   * @example "batteries"
   */
  correctedTerm?: string;
}

/** Response model to represent the category result. */
export interface CategoryModel {
  /**
   * This indicates the display name that the category belong to.
   * @example "Brakes and Traction Control"
   */
  categoryName?: string;
  /**
   * Part Group identifier that this part type is part of.
   * @example "azpg1234"
   */
  partGroupId?: string;
  /**
   * Canonical Url for the Part Group
   * @example "/brakes-and-abs/parking-brake-hardware"
   */
  canonicalUrl?: string;
  /**
   * This indicates the taxonomy path that the category belong to.
   * @example "/parts/brakes-and-traction-control"
   */
  taxonomyPath?: string;
  /**
   * This indicates the category id that the category belong to.
   * @example "d0a7b334-6fb9-4ce6-a6f9-a2874d73/0530d388-0205-4a72-b307-b5a7458e/8b028372-b297-48fd-8585-d7bca4cf"
   */
  categoryIdPath?: string;
  /**
   * This indicates the page type that the category belong too and it could be one of from TopNavCategory, CategoryGrouping, LeafCategory and PartGroup.
   * @example "CategoryGrouping"
   */
  pageType?: string;
}

/**  Response model to represent the menu results, this contains information about root categories, child categories and also most popular categories depending on current level. */
export interface CategoryResponseModel {
  /** This property contains all categories from catalog hierarchy. */
  categoryResults?: CategoryResultsModel[];
  /** This property contains all categories from catalog hierarchy. */
  breadCrumbs?: BreadcrumbModel[];
  /** This property contains all the most popular parts. */
  popularParts?: PopularPartModel[];
  /**
   * This indicates the shop by url that the product belong to.
   * @example "/honda/civic/2018"
   */
  makeModelYearPath?: string;
  /**
   * year of the vehicle from the search
   * @format int32
   * @example 2022
   */
  year?: number;
  /**
   * make Id of the vehicle from the search
   * @format int32
   * @example 25
   */
  makeId?: number;
  /**
   * model Id of the vehicle from the search
   * @format int32
   * @example 187
   */
  modelId?: number;
  /**
   * make name of the vehicle from the search
   * @example "Honda"
   */
  makeName?: string;
  /**
   * model name of the vehicle from the search
   * @example "Accord"
   */
  modelName?: string;
  /**
   * sub model name of the vehicle from the search
   * @example "SCT"
   */
  subModelName?: string;
}

/** Response model to represent the category results which contain an information related to categories and breadcrumbs along with most popular parts from them. */
export interface CategoryResultsModel {
  /**
   * This indicates the display name that the category belong to.
   * @example "Automotive Parts"
   */
  categoryName?: string;
  /**
   * Part Group identifier that this part type is part of.
   * @example "azpg1234"
   */
  partGroupId?: string;
  /**
   * Canonical Url for the Part Group
   * @example "/brakes-and-abs/parking-brake-hardware"
   */
  canonicalUrl?: string;
  /**
   * This indicates the taxonomy path that the category belong to.
   * @example "/parts"
   */
  taxonomyPath?: string;
  /**
   * This indicates the category id that the category belong to.
   * @example "d0a7b334-6fb9-4ce6-a6f9-a2874d73/0530d388-0205-4a72-b307-b5a7458e/8b028372-b297-48fd-8585-d7bca4cf"
   */
  categoryIdPath?: string;
  /**
   * This indicates the page type that the category belong too and it could be one of from TopNavCategory, CategoryGrouping and LeafCategory.
   * @example "CategoryGrouping"
   */
  pageType?: 'TopLevel' | 'CategoryGrouping' | 'LeafCategory' | 'PartGroup';
  /** The list of subcategories for the parent category. */
  childCategories?: CategoryModel[];
  /** This contains all the breadcrumbs for the category. */
  breadCrumbs?: BreadcrumbModel[];
}

/** Response model to represent the PopularPart result. */
export interface PopularPartModel {
  /**
   * This indicates the taxonomy id that the part belong to.
   * @example "d0a7b334-6fb9-4ce6-a6f9-a2874d73/0530d388-0205-4a72-b307-b5a7458e/8b028372-b297-48fd-8585-d7bca4cf/1744"
   */
  categoryIdPath?: string;
  /**
   * This indicates the display name that the part belong to.
   * @example "Battery"
   */
  displayName?: string;
  /**
   * Part Group identifier that this part type is part of.
   * @example "azpg1234"
   */
  partGroupId?: string;
  /**
   * This indicates the taxonomy path that the category belong to.
   * @example "/parts/batteries-starting-and-charging/batteries/battery"
   */
  taxonomyPath?: string;
  /**
   * This indicates the page type that the category belong too and it could be one of from TopNavCategory, CategoryGrouping, LeafCategory and PartGroup.
   * @example "ProductShelf"
   */
  pageType?: string;
  /**
   * Canonical Url for the Part Group
   * @example "/brakes-and-abs/parking-brake-hardware"
   */
  canonicalUrl?: string;
}

/** Brand shelf response model for client consumption. */
export interface BrandShelfResponseModel {
  /** Search results for brand */
  brandShelfResults?: BrandShelfResultsModel;
  /**
   * This is used to uniquely identify a request as well as perform stable access tracing.
   * @example "bQK4aRXbmE"
   */
  xfusionQueryId?: string;
}

/** Response model to represent products at the brand level along with related facets. */
export interface BrandShelfResultsModel {
  /** An applicable facets list for the search results. */
  facets?: FacetModel[];
  /** An applicable facets list for quick selection in the search results. */
  quickFilters?: FacetModel[];
  /**
   * The first record number from the search results
   * @format int32
   * @example 1
   */
  firstRecordNumber?: number;
  /**
   * The last record number from the search results
   * @format int32
   * @example 12
   */
  lastRecordNumber?: number;
  /**
   * The number of records to display on the page
   * @format int32
   * @example 12
   */
  recordsPerPage: number;
  /**
   * The total number of records returned from the search
   * @format int32
   * @example 200
   */
  totalNumberOfRecords?: number;
  /**
   * year of the vehicle from the search
   * @format int32
   * @example 2022
   */
  year?: number;
  /**
   * make Id of the vehicle from the search
   * @format int32
   * @example 25
   */
  makeId?: number;
  /**
   * model Id of the vehicle from the search
   * @format int32
   * @example 187
   */
  modelId?: number;
  /**
   * make name of the vehicle from the search
   * @example "Honda"
   */
  makeName?: string;
  /**
   * model name of the vehicle from the search
   * @example "Accord"
   */
  modelName?: string;
  /**
   * sub model name of the vehicle from the search
   * @example "SCT"
   */
  subModelName?: string;
  /**
   * sub model id of the vehicle from the search
   * @format int32
   * @example 671
   */
  subModelId?: number;
  /**
   * unitOfMeasureMatch is a Boolean that returns true if a product is searched with any unit of measure.
   * @example false
   */
  unitOfMeasureMatch?: boolean;
  /**
   * This indicates the brand name in the top of the page
   * @example "A/C PRO PARTS AND PRODUCTS"
   */
  brandName?: string;
  /** A list of matched Stock Keeping Unit (SKU) records from the search */
  skuRecords?: SkuRecordModel[];
  /** List of the vehicle specifications. */
  specifications?: TwaDocumentModel[];
  /** List of the Installation Instructions available for the vehicle. */
  installationInstructions?: TwaDocumentModel[];
  /** List of the trusted advices available for the vehicle. */
  trustedAdvices?: TwaDocumentModel[];
  /** List of the component locations available for the vehicle. */
  componentLocations?: TwaDocumentModel[];
}

/** Response Model for Product Details Autocomplete Suggestions */
export interface ProductTitleSuggestionModel {
  /**
   * Property to hold the value for suggested product url that redirects to product details page (pdp) when user click on it
   * @example "/batteries-starting-and-charging/battery/p/duralast-battery-75dt-dl-group-size-75-650-cca/1080223_0_0"
   */
  productDetailsPageUrl?: string;
  /**
   * Property to hold the value for product's image url
   * @example "/images/duralast-battery.jpg"
   */
  productImageUrl?: string;
  /**
   * Property to hold the value for suggested term in this case is the product title
   * @example "Duralast Battery"
   */
  itemDescription?: string;
  /**
   * Property to hold vehicleFitment
   * @example "FIT"
   */
  vehicleFitment?: string;
  /**
   * Property to hold partGroupId
   * @example "azpg1490"
   */
  partGroupId?: string;
  /**
   * This indicates the productCanonicalUrl that the product belong too.
   * @example "Alternator"
   */
  productCanonicalUrl?: string;
}

/** Represents the suggestions based on the search term and other associated parameters. */
export interface SuggestionTypesModel {
  /**
   * A list of suggestions that may refer to categories or part types or other related terms.
   * @example ["air filter","cabin air filter","mass air flow sensor","spark plug wire","idle air control valve","engine air filter","air compressor","air intake","air freshener","cold air intake"]
   */
  generalSuggestions?: string[];
  /** A list of suggestions that specifically refer to product titles */
  productTitleSuggestions?: ProductTitleSuggestionModel[];
}

export interface WebApiErrorModel {
  code?: string;
  message?: string;
  target?: string;
  details?: WebApiErrorModel[];
  innerError?: WebApiErrorModel;
}

export interface WebApiErrorResponseModel {
  error?: WebApiErrorModel;
}

export interface GetSolrSearchParamsModel {
  /**
   * Catalog type in Solr to which the request should be sent. If deployment is not specified, Parts Pro catalog is accessed.
   * @example "partspro"
   */
  catalog?: 'partspro' | 'diy' | 'comm';
  /**
   * Additional query parameters to pass to Solr.
   * @example {"collection-name":"DIFM_USA","q":"oil filter","synonyms":"oil,engine oil"}
   */
  queryParams: Record<string, string>;
  /**
   * The Solr handler to use for the search.
   * @example "semanticSearch"
   */
  solrHandler: string;
  /**
   * The semantic search to perform.
   * @example "autozone_comm_usa_concepts_live"
   */
  collectionName: string;
}

export interface GetShopByYearParamsModel {
  /**
   * The type of customer that is requesting the information. For this endpoint is only B2C available
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The flag to preview the changes in site before they're deployed to production.
   * @default false
   */
  preview?: boolean;
  /**
   * Taxonomy path associated with the searched years.
   * @example "/air-conditioning-heating/ac-condenser-components"
   */
  taxonomyPath?: string;
  /**
   * Taxonomy id associated with the searched years.
   * @example "03dd55d3-545f-4a6e-b904-6fa9f560/b588a827-72c2-46e3-a2a4-4af53d4d"
   */
  categoryIdPath?: string;
  /**
   * Part Group id associated with the searched years.
   * @example "azpg2128"
   */
  partGroupId?: string;
  /**
   * Make id associated with the searched years.
   * @format int32
   * @example 59
   */
  makeId: number;
  /**
   * Model id associated with the searched years.
   * @format int32
   * @example 751
   */
  modelId: number;
  /**
   * Optional year filter
   * @format int32
   * @example 2009
   */
  year?: number;
  /**
   * Year type. The default is ALL. For ALTERNATE, we need to check the year provided as input and return the previous year and the next year
   * @default "ALL"
   * @example "ALL"
   */
  yearBlockType?: 'ALL' | 'ALTERNATE';
}

export interface GetShopByModelParamsModel {
  /**
   * The type of customer that is requesting the information. For this endpoint is only B2C available
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The flag to preview the changes in site before they're deployed to production.
   * @default false
   */
  preview?: boolean;
  /**
   * Taxonomy path associated with the searched models.
   * @example "/air-conditioning-heating/ac-condenser-components"
   */
  taxonomyPath?: string;
  /**
   * Taxonomy id associated with the searched models.
   * @example "03dd55d3-545f-4a6e-b904-6fa9f560/b588a827-72c2-46e3-a2a4-4af53d4d"
   */
  categoryIdPath?: string;
  /**
   * Part Group id associated with the searched models.
   * @example "azpg2128"
   */
  partGroupId?: string;
  /**
   * Make id associated with the searched models.
   * @format int32
   * @example 47
   */
  makeId: number;
}

export interface GetShopByMakeParamsModel {
  /**
   * The type of customer that is requesting the information. For this endpoint is only B2C available
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The flag to preview the changes in site before they're deployed to production.
   * @default false
   */
  preview?: boolean;
  /**
   * Taxonomy path associated with the searched makes.
   * @example "/air-conditioning-heating/ac-condenser-components"
   */
  taxonomyPath?: string;
  /**
   * Taxonomy id associated with the searched makes.
   * @example "03dd55d3-545f-4a6e-b904-6fa9f560/b588a827-72c2-46e3-a2a4-4af53d4d"
   */
  categoryIdPath?: string;
  /**
   * Part Group id associated with the searched makes.
   * @example "azpg2128"
   */
  partGroupId?: string;
}

export interface GetProductListResultParamsModel {
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property.
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The searched keyword that is associated with user search which be used to filter out products.
   * @example "battery"
   */
  searchedKeyword?: string;
  /**
   * The sort that is associated to the sort by option applied by user from the shelf brand page.
   * @example "featured"
   */
  sort?: SortingTypeModel;
  /**
   * The store id that is associated with user which will be used to filter out categories.
   * @format int32
   * @example 6998
   */
  storeId?: number;
  /**
   * The user segments is associated with user properties and the values should be given as comma separated if there is more than one segment for this property and it will be used to filter out categories.
   * @example "NDD_MidNIght_Mkts"
   */
  userSegments?: string;
  /**
   * The year of the user's selected vehicle.
   * @format int32
   * @example 2011
   */
  year?: number;
  /**
   * The make ID of the user's selected vehicle.
   * @format int32
   * @example 76
   */
  makeId?: number;
  /**
   * The model ID of the user's selected vehicle.
   * @format int32
   * @example 1033
   */
  modelId?: number;
  /**
   * The vehicle type ID of the user's selected vehicle.
   * @format int32
   * @example 6
   */
  vehicleTypeId?: number;
  /**
   * The record type of the products searched for.
   * @example "APP"
   */
  recordType?: 'ALL' | 'APP' | 'NON_APP';
  /**
   * Question and Answer mapping for vehicle identification. The field is not case format sensitive; both camelCase and snake_case are acceptable.
   * @example "sub_model_id:968||engine_base_id:2096_765_323"
   */
  vehicleQuestions?: string;
  /**
   * The ignoreVehicleSpecificProductsCheck flag indicates whether Vehicle Specific Products Check is required or not.
   * @default false
   * @example false
   */
  ignoreVehicleSpecificProductsCheck?: boolean;
  /**
   * Indicated whether preview data should be used
   * @default false
   */
  preview?: boolean;
}

export interface GetProductListResultsParamsModel {
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property.
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * Part Group identifier that this part type is part of.
   * @example "azpg4204"
   */
  partGroupId: string;
  /**
   * The facet details that is associated with user selection(s) which will be used to filter out products.
   * @example "position_name_s:Front+Rear++padbattr_facet_30_s:No"
   */
  facet?: string;
  /**
   * The min price that is associated to the price applied by user from the price facet.
   * @format int32
   * @example 10
   */
  minPrice?: number;
  /**
   * The max price that is associated to the price applied by user from the price facet.
   * @format int32
   * @example 50
   */
  maxPrice?: number;
  /**
   * The facet path details that is associated with user selection(s) added in the url path which will be used to filter out products. This property would be used to support legacy filter id to new fact value mapping.
   * @example "/b/brand/duralast~duralast-platinum"
   */
  botEnabledFacetPath?: string;
  /**
   * The searched keyword that is associated with user search which be used to filter out products.
   * @example "brake"
   */
  searchedKeyword?: string;
  /**
   * The partNumberSearch flag indicates whether request is generated from a PartNumber search results page.
   * @default false
   * @example false
   */
  partNumberSearch?: boolean;
  /**
   * The page number that is associated with user viewing where the default is first page.
   * @format int32
   * @default 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * The records per page that is associated to the number of SKU records to show on the page.
   * @format int32
   * @default 24
   * @example 12
   */
  recordsPerPage?: number;
  /**
   * The sort that is associated to the sort by option applied by user from the shelf page.
   * @default "featured"
   * @example "price-desc"
   */
  sort?: SortingTypeModel;
  /**
   * The Make/Model/Year path that is assosicated to the mmy details from the canonical path.
   * @example "/mitsubishi/lancer/2011"
   */
  makeModelYearPath?: string;
  /**
   * The store id that is associated with user which will be used to filter out categories.
   * @format int32
   * @example 6998
   */
  storeId?: number;
  /**
   * The ignoreVehicleSpecificProductsCheck flag indicates whether Vehicle Specific Products Check is required or not.
   * @default false
   * @example false
   */
  ignoreVehicleSpecificProductsCheck?: boolean;
  /**
   * The preview flag is associated to preview the changes in site before its deployed to production.
   * @default false
   * @example false
   */
  preview?: boolean;
  /** The list of tags associated with LW rules, used to filter out the applicable rules. Example: CLEARANCE */
  ruleTags?: string;
  /**
   * The year of the user's selected vehicle.
   * @format int32
   * @example 2011
   */
  year?: number;
  /**
   * The make ID of the user's selected vehicle.
   * @format int32
   * @example 72
   */
  makeId?: number;
  /**
   * The model ID of the user's selected vehicle.
   * @format int32
   * @example 307
   */
  modelId?: number;
  /**
   * The vehicle type ID of the user's selected vehicle.
   * @format int32
   * @example 5
   */
  vehicleTypeId?: number;
  /**
   * The record type of the products searched for.
   * @example "APP"
   */
  recordType?: 'ALL' | 'APP' | 'NON_APP';
  /**
   * Question and Answer mapping for vehicle identification. The field is not case format sensitive; both camelCase and snake_case are acceptable.
   * @example "subModelId:78||driveTypeId:15"
   */
  vehicleQuestions?: string;
  /**
   * Indicates if interchange search should match exactly the search term. Only for B2B customers
   * @example true
   */
  exact?: boolean;
  /**
   * Indicates if it is interchange search request. Only for B2B customers
   * @example true
   */
  interchange?: boolean;
}

export interface GetPartGroupsParamsModel {
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The flag to preview the changes in site before they're deployed to production.
   * @default false
   */
  preview?: boolean;
  /**
   * Standarized ACES/PIES part terminology identifier. Used to ensure consistency and accuracy when exchanging information about parts between manufacturers, suppliers, and retailers. Separate by commas to pass multiple group ids. There should be no space(s) anywhere.
   * @example "2476,5900"
   */
  partTerminologyId: string;
}

export interface GetPartInterchangesParamsModel {
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "B2B"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property.
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * List of part numbers to search.
   * @minLength 1
   * @maxLength 12
   * @example "49191,52450651"
   */
  partNumbers: string;
  /**
   * The part has been/not been certified for collision repair use
   * @example true
   */
  collisionFlag: boolean;
  /**
   * The page number that is associated with user viewing where the default is first page.
   * @format int32
   * @min 1
   * @default 1
   * @example 1
   */
  pageNumber?: number;
  /**
   * The records per page that is associated to the number of SKU records to show on the page.
   * @format int32
   * @min 1
   * @default 10
   * @example 12
   */
  recordsPerPage?: number;
  /**
   * The store id that is associated with user which will be used to filter out categories.
   * @format int32
   * @example 6998
   */
  storeId?: number;
  /**
   * The year of the user's selected vehicle.
   * @format int32
   * @example 1993
   */
  year?: number;
  /**
   * The make ID of the user's selected vehicle.
   * @format int32
   * @example 47
   */
  makeId?: number;
  /**
   * The model ID of the user's selected vehicle.
   * @format int32
   * @example 454
   */
  modelId?: number;
  /**
   * The vehicle type ID of the user's selected vehicle.
   * @format int32
   * @example 6
   */
  vehicleTypeId?: number;
  /**
   * Question and Answer mapping for vehicle identification. The field is not case format sensitive; both camelCase and snake_case are acceptable.
   * @example "subModelId:444||driveTypeId:9"
   */
  vehicleQuestions?: string;
  /**
   * Indicated whether preview data should be used
   * @default false
   */
  preview?: boolean;
}

export interface GetPartTerminologyIdsParamsModel {
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * Part Group identifier that this part type is part of. Separate by commas to pass multiple group ids. There should be no space(s) anywhere.
   * @example "azpg4204,azpg1930"
   */
  partGroupId: string;
  /**
   * The flag to preview the changes in site before they're deployed to production.
   * @default false
   */
  preview?: boolean;
}

export interface FindPageTypeParamsModel {
  /**
   * The flag to preview the changes in site before they're deployed to production.
   * @default false
   */
  preview?: boolean;
  /**
   * The country code that is associated with the country requesting the information.
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The canonical path that is associated with the category information requested for. This property would be used for the bookmarked url(s) and search engine(s).
   * @example "/batteries-starting-and-charging/battery/honda/civic/2012/b/brand/duralast"
   */
  canonicalPath: string;
}

export interface GetMerchListResultsParamsModel {
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property.
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The canonical path that is associated with the category information requested for. This property would be used for the direct shelf page url(s), bookmarked url(s) and search engine(s).
   * @example "/deals/clearance"
   */
  canonicalPath?: string;
  /**
   * The facet details that is associated with user selection(s) which will be used to filter out products.
   * @example "universal_or_specific_fit_s:UNIVERSAL++brand_name_s:Duralast+Optima Batteries"
   */
  facet?: string;
  /**
   * The min price that is associated to the price applied by user from the price facet.
   * @format int32
   * @example 10
   */
  minPrice?: number;
  /**
   * The max price that is associated to the price applied by user from the price facet.
   * @format int32
   * @example 50
   */
  maxPrice?: number;
  /**
   * The facet path details that is associated with user selection(s) added in the url path which will be used to filter out products. This property would be used to support legacy filter id to new fact value mapping.
   * @example "/b/brand/duralast~duralast-platinum"
   */
  botEnabledFacetPath?: string;
  /**
   * The searched keyword that is associated with user search which be used to filter out products.
   * @example "battery"
   */
  searchedKeyword?: string;
  /**
   * The partNumberSearch flag indicates whether request is generated from a PartNumber search results page.
   * @default false
   * @example false
   */
  partNumberSearch?: boolean;
  /**
   * The page number that is associated with user viewing where the default is first page.
   * @format int32
   * @default 0
   * @example 1
   */
  pageNumber?: number;
  /**
   * The records per page that is associated to the number of SKU records to show on the page.
   * @format int32
   * @default 24
   * @example 12
   */
  recordsPerPage?: number;
  /**
   * The sort that is associated to the sort by option applied by user from the shelf page.
   * @default "featured"
   * @example "price-desc"
   */
  sort?: SortingTypeModel;
  /**
   * The Make/Model/Year path that is assosicated to the mmy details from the canonical path.
   * @example "/honda/civic"
   */
  makeModelYearPath?: string;
  /**
   * The store id that is associated with user which will be used to filter out categories.
   * @format int32
   * @example 6998
   */
  storeId?: number;
  /**
   * The ignoreVehicleSpecificProductsCheck flag indicates whether Vehicle Specific Products Check is required or not.
   * @default false
   * @example false
   */
  ignoreVehicleSpecificProductsCheck?: boolean;
  /**
   * The preview flag is associated to preview the changes in site before its deployed to production.
   * @default false
   * @example false
   */
  preview?: boolean;
  /**
   * The list of tags associated with LW rules, used to filter out the applicable rules.
   * @example "CLEARANCE"
   */
  partGroupRules: string;
  /**
   * The year of the user's selected vehicle.
   * @format int32
   * @example 2011
   */
  year?: number;
  /**
   * The make ID of the user's selected vehicle.
   * @format int32
   * @example 72
   */
  makeId?: number;
  /**
   * The model ID of the user's selected vehicle.
   * @format int32
   * @example 556
   */
  modelId?: number;
  /**
   * The vehicle type ID of the user's selected vehicle.
   * @format int32
   * @example 5
   */
  vehicleTypeId?: number;
  /**
   * The record type of the products searched for.
   * @example "APP"
   */
  recordType?: 'ALL' | 'APP' | 'NON_APP';
  /**
   * Question and Answer mapping for vehicle identification. The field is not case format sensitive; both camelCase and snake_case are acceptable.
   * @example "subModelId:21||driveTypeId:15"
   */
  vehicleQuestions?: string;
  /**
   * Indicates if interchange search should match exactly the search term. Only for B2B customers
   * @example true
   */
  exact?: boolean;
  /**
   * Indicates if it is interchange search request. Only for B2B customers
   * @example true
   */
  interchange?: boolean;
  /**
   * Generated by Tealium and sent as a first party cookie on initial visit, then reused on subsequent visits when passed to the Elastic/Vertex APIs
   * @example "019b5ba1f57100819c03abdd04e805075001f06d00bd0"
   */
  visitorId?: string;
  /**
   * Populated with GCM ID for signed in users
   * @example "101350086"
   */
  userId?: string;
}

export interface GetShopByMake1ParamsModel {
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The flag to preview the changes in site before they're deployed to production.
   * @default false
   */
  preview?: boolean;
  /**
   * This parameter identifies how the filter terms and links will be used. For example, shopbymake, shopbymodel or shopbybrand.
   * @example "SHOP_BY_MAKE"
   */
  filterLinksUsage: 'SHOP_BY_MAKE' | 'SHOP_BY_MODEL' | 'SHOP_BY_BRAND' | 'SHOP_BY_ALL_BRAND';
}

export interface GetCategoriesParamsModel {
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property.
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The preview flag is associated to preview the changes in site before its deployed to production.
   * @default false
   * @example false
   */
  preview?: boolean;
  /**
   * The category id of the category to search for subcategories.
   * @example ["2cd4700a-8120-4a81-9197-048c1b64/1091e755-0aa3-4ad4-bb1b-be64f27d"]
   */
  categoryIdPath?: string[];
  /**
   * Parameter that indicates that searched categories should be top-level.
   * @default false
   * @example false
   */
  isPartsUrl?: boolean;
  /**
   * The Store Id to be exclude from categories search.
   * @format int32
   * @example 1766
   */
  storeId?: number;
  /**
   * The year of the user's selected vehicle.
   * @format int32
   * @example 2011
   */
  year?: number;
  /**
   * The make ID of the user's selected vehicle.
   * @format int32
   * @example 72
   */
  makeId?: number;
  /**
   * The model ID of the user's selected vehicle.
   * @format int32
   * @example 556
   */
  modelId?: number;
  /**
   * The vehicle type ID of the user's selected vehicle.
   * @format int32
   * @example 5
   */
  vehicleTypeId?: number;
  /**
   * The Make/Model/Year path that is associated to the mmy details from the canonical path.
   * @example "/honda/civic"
   */
  makeModelYearPath?: string;
  /**
   * Question and Answer mapping for vehicle identification. The field is not case format sensitive; both camelCase and snake_case are acceptable.
   * @example "subModelId:21||driveTypeId:9"
   */
  vehicleQuestions?: string;
  /**
   * The record type of the products searched for.
   * @example "APP"
   */
  recordType?: 'ALL' | 'APP' | 'NON_APP';
  /**
   * The user segments is associated with user properties and the values should be given as comma separated if there is more than one segment for this property and it will be used to filter out categories.
   * @example "NDD_Segment_Pref_Stores"
   */
  userSegments?: string;
}

export interface GetBrandListResultsParamsModel {
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property.
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The facet details that is associated with user selection(s) which will be used to filter out products per brand.
   * @example "sub_brand_name_display_s:ACDelco Gold++position_name_s:Driver Side+Passenger Side"
   */
  facet?: string;
  /**
   * The min price that is associated to the price applied by user from the price facet.
   * @format int32
   * @example 10
   */
  minPrice?: number;
  /**
   * The max price that is associated to the price applied by user from the price facet.
   * @format int32
   * @example 50
   */
  maxPrice?: number;
  /**
   * The page number that is associated with user viewing where the default is first page.
   * @format int32
   * @default 1
   * @example 1
   */
  pageNumber?: number;
  /**
   * The records per page that is associated to the number of SKU records to show on the page.
   * @format int32
   * @default 12
   * @example 12
   */
  recordsPerPage?: number;
  /**
   * The sort that is associated to the sort by option applied by user from the shelf brand page.
   * @example "featured"
   */
  sort?: SortingTypeModel;
  /**
   * Used to filter product responses matching the given brand URL path.
   * @example "/brands/acdelco"
   */
  seoUrl: string;
  /**
   * The store id that is associated with user which will be used to filter out categories.
   * @format int32
   * @example 6998
   */
  storeId?: number;
  /**
   * The user segments is associated with user properties and the values should be given as comma separated if there is more than one segment for this property and it will be used to filter out categories.
   * @example "NDD_MidNIght_Mkts"
   */
  userSegments?: string;
  /**
   * The year of the user's selected vehicle.
   * @format int32
   * @example 2008
   */
  year?: number;
  /**
   * The make ID of the user's selected vehicle.
   * @format int32
   * @example 59
   */
  makeId?: number;
  /**
   * The model ID of the user's selected vehicle.
   * @format int32
   * @example 751
   */
  modelId?: number;
  /**
   * The vehicle type ID of the user's selected vehicle.
   * @format int32
   * @example 5
   */
  vehicleTypeId?: number;
  /**
   * The record type of the products searched for.
   * @example "APP"
   */
  recordType?: 'ALL' | 'APP' | 'NON_APP';
  /**
   * Question and Answer mapping for vehicle identification. The field is not case format sensitive; both camelCase and snake_case are acceptable.
   * @example "subModelId:21||driveTypeId:9"
   */
  vehicleQuestions?: string;
  /**
   * The ignoreVehicleSpecificProductsCheck flag indicates whether Vehicle Specific Products Check is required or not.
   * @default false
   * @example false
   */
  ignoreVehicleSpecificProductsCheck?: boolean;
  /**
   * Indicated whether preview data should be used
   * @default false
   */
  preview?: boolean;
}

export interface GetTypeaheadsParamsModel {
  /**
   * The type of customer that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "B2C"
   */
  customerType: 'B2C' | 'B2B';
  /**
   * The sales channel that is requesting the information. Check below the acceptable Enum values for this property.
   * @example "ECOMM"
   */
  salesChannel: 'ECOMM' | 'STORE';
  /**
   * The country code that is associated with the country requesting the information. Check below the acceptable Enum values for this property.
   * @example "USA"
   */
  country: 'USA' | 'MEX' | 'BRA';
  /**
   * The current text entered to provide predictive suggestions for. It may be a partial word or phrase.
   * @example "air"
   */
  searchTerm?: string;
  /**
   * The preview flag is associated to preview the changes in site before its deployed to production.
   * @default false
   * @example false
   */
  preview?: boolean;
  /**
   * The year of the user's selected vehicle.
   * @format int32
   * @example 2011
   */
  year?: number;
  /**
   * The make ID of the user's selected vehicle.
   * @format int32
   * @example 72
   */
  makeId?: number;
  /**
   * The model ID of the user's selected vehicle.
   * @format int32
   * @example 556
   */
  modelId?: number;
  /**
   * The vehicle type ID of the user's selected vehicle.
   * @format int32
   * @example 5
   */
  vehicleTypeId?: number;
  /**
   * Question and Answer mapping for vehicle identification. The field is not case format sensitive; both camelCase and snake_case are acceptable.
   * @example "subModelId:21||driveTypeId:15"
   */
  vehicleQuestions?: string;
  /**
   * The store id associated with the store that is requesting the information. The store id must be provided to identify the region for improving suggestion accuracy.
   * @format int32
   * @example 1766
   */
  storeId?: number;
}
